import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { PopoverRef } from 'src/@vex/components/popover/popover-ref';
import { IExaminationSchedule, ICandidate } from 'src/app/interface/dto';
import { examinationScheduleDefault } from 'src/app/interface/dtoDefaults';
import { ExamScheduleService } from 'src/app/services/exam-schedule-service';
import { ExamService } from 'src/app/services/exam-service.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { Util } from 'src/app/services/Util';
import { ExamScheduleFlagsComponent } from '../exam-schedule-flags/exam-schedule-flags.component';

@Component({
  selector: 'app-add-schedule-flags',
  templateUrl: './add-schedule-flags.component.html',
  styleUrls: ['./add-schedule-flags.component.scss']
})
export class AddScheduleFlagsComponent implements OnInit {


  constructor(private popoverRef: PopoverRef<any>, private examSchService: ExamScheduleService,
    private snackBar: SnackbarService,) { }
  examSchedule: IExaminationSchedule = examinationScheduleDefault;
  flagReason: string = '';

  async ngOnInit() {
    this.examSchedule = this.examSchService.selectedSchedules[0];
  }
  flagCandidate() {
    if (this.flagReason.trim().length == 0) {
      this.snackBar.error('Please provide a reason for flagging the candidate(s)');
      return;
    }
    let data = {
      ExaminationScheduleID: this.examSchedule.id,
      FlaggedComment: this.flagReason,
      Attempt: this.examSchedule.attempt
    }
    this.examSchService.flagSchedule(data).then((res: any) => {
      this.snackBar.success('Flagged Added Successfully');
      this.popoverRef.close(true);
      this.examSchService.reloadGrid.next(true);
    }).catch(err => {
      this.snackBar.error(err || 'Error flagging candidate');
    });
  }

  close() {
    this.popoverRef.close();
  }
}
